import { useEffect, useState, useRef } from "react"
import { TEMPLATEOPTIONS } from "../../../constant/emailTemplates"
import { ref, set, child, get, onValue } from "firebase/database";
import { db, defaultNudgeDb, testDb } from "../../../firebase";
import { DefaultTemplateDisplay } from "../templateDisplays/DefaultTemplateDisplay";
import { Button } from "../../../components";
import { GoPencil } from "react-icons/go";
import { handleDefaultSave } from "../../../helper/emailTemplates/saveEmailTemplates/handleDefaultSave";
import { AiOutlineCloudUpload } from "react-icons/ai";



export function DefaultTemplate({ user }) {

    const activeButton = useRef(null);
    const [templateFields, setTemplateFields] = useState({});
    const [initialData, setInitialData] = useState({})
    const [customizeState, setCustomizeState] = useState({})
    const [loading, setLoading] = useState(true)

    // Retrieve information from database
    useEffect(() => {
        try {
            if (Object.keys(customizeState).length === 0) {

                const dbRef = ref(testDb, `testuser-prod/emailTemplates/defaultTemplate`);
                onValue(dbRef, async (snapshot) => {
                    if (snapshot.exists()) {
                        // Will run when data saved into database
                        setCustomizeState(snapshot.val())
                        setInitialData(snapshot.val())
                        setTemplateFields(snapshot.val().title);
                        setLoading(false)
                    }
                    else {
                        setCustomizeState(TEMPLATEOPTIONS.defaultTemplate)
                        setInitialData(TEMPLATEOPTIONS.defaultTemplate)
                        setTemplateFields(TEMPLATEOPTIONS.defaultTemplate.title);
                        setLoading(false)
                    }
                })
            }
        } catch (err) {
            console.log(err)
        }
    }, [])


    const handleTemplateOptionClick = (option) => {
        setTemplateFields(option)
        activeButton.current = option.optionValue;
    }





    return (
        <div>
            {loading ? <></> :
                <div>
                    {/* Customizable fields */}
                    <div className="persona__nudge bg-color border border-neutral-600 dark:border-neutral-800 rounded shadow-sm shadow-blue-800 w-full p-2 sm:p-4 mb-2">
                        <p className="nudge__title text-base sm:text-2xl text-center"></p>
                        <div className="optionContainer lg:flex py-8 ">
                            <TemplateOptions
                                initialData={initialData}
                                activeButton={activeButton.current}
                                handleTemplateOptionClick={handleTemplateOptionClick}
                            />
                            <TemplateFields
                                templateFields={templateFields}
                                setTemplateFields={setTemplateFields}
                                customizeState={customizeState}
                                handleSave={() => handleDefaultSave(initialData, customizeState, 'defaultTemplate')}
                                setCustomizeState={setCustomizeState}
                            />

                        </div>
                    </div>
                    <div style={{border: '1px solid black', maxWidth: '800px'}}>
                        <DefaultTemplateDisplay customizeState={customizeState} />
                    </div>
                </div>
            }
        </div>
    )
}






const TemplateOptions = (props) => {

    const { initialData, activeButton, handleTemplateOptionClick } = props;

    return (
        <div className="customisableOptions lg:w-1/2 p-2">
            <div className="flex">
                <h3 className='mx-auto text-xl font-semibold'>Customize Template Properties</h3>
            </div>
            <div className="options">
                {
                    Object.entries(initialData ? initialData : {}).map(([entryName, entryValue], index) => <Option key={index} title={entryValue.optionName} value={entryValue} activeButton={activeButton} onClick={() => handleTemplateOptionClick(entryValue)} />)
                }
            </div>
        </div>
    )
}

const Option = (props) => {
    const { title, value, activeButton, onClick } = props;
    return (
        <div className="option flex items-center justify-between mt-2 px-5 ">
            <p className="optionHeading">{title}</p>
            <Button Icon={GoPencil} active={value.optionValue === activeButton} onClick={onClick} title="CUSTOMIZE" />
        </div>
    )
}







const TemplateFields = (props) => {

    const { templateFields, setTemplateFields, customizeState, setCustomizeState, handleSave } = props;

    return (
        <div className="customisableFields lg:w-1/2 p-2">
            <div className="flex">
                <h3 className='mx-auto text-xl font-semibold'>{templateFields.optionName}</h3>
            </div>
            <div className="fields">
                {
                    templateFields?.customizeProperties && Object.entries(templateFields?.customizeProperties).map(([propertyName, propertyValue], index) =>
                        <Fields
                            key={index}
                            propertyName={propertyName}
                            property={propertyValue}
                            customizeState={customizeState}
                            setCustomizeState={setCustomizeState}
                            templateFields={templateFields}
                            setTemplateFields={setTemplateFields}
                        />
                    )
                }
            </div>
            <div className="buttons flex mt-4 items-center justify-center">
                <Button Icon={AiOutlineCloudUpload} active={false} onClick={handleSave} title="SAVE" />
            </div>
        </div>
    )
}



const Fields = (props) => {

    const [maxLengthErrorText, setMaxLengthErrorText] = useState("")

    const { propertyName, property, customizeState, setCustomizeState, templateFields, setTemplateFields } = props;

    const handleTemplateFieldsChange = (name, value) => {
        // check if text length is greater than property.propertyMaxLength
        if (property.propertyMaxLength && value.length > property.propertyMaxLength) {
            setMaxLengthErrorText(`Max length is ${property.propertyMaxLength}`);
            return;
        }
        setMaxLengthErrorText('');

        let state = {
            ...customizeState,
            [templateFields.optionValue]: {
                ...customizeState[templateFields.optionValue],
                customizeProperties: {
                    ...customizeState[templateFields.optionValue].customizeProperties,
                    [name]: {
                        ...customizeState[templateFields.optionValue].customizeProperties[name],
                        propertyValue: value
                    }
                }
            }
        }
        setCustomizeState(state);
        // update templateFields
        let fields = {
            ...templateFields,
            customizeProperties: {
                ...templateFields.customizeProperties,
                [name]: {
                    ...templateFields.customizeProperties[name],
                    propertyValue: value,
                },
            },
        }
        setTemplateFields(fields);
    }


    

    return (
        <div className="textField flex flex-col gap-2 px-5 mt-2">
            <div className="textField__container flex items-center justify-between">
                {
                    <RenderField
                        property={property}
                        propertyName={propertyName}
                        handleTemplateFieldsChange={handleTemplateFieldsChange}
                    />
                }
            </div>
            <span className="text-red-500 text-sm">{maxLengthErrorText}</span>
        </div>
    )
};

const RenderField = (props) => {

    const { property, propertyName, handleTemplateFieldsChange } = props;

    switch (property.propertyType) {
        case 'select':
            return <Select property={property} propertyName={propertyName} handleTemplateFieldsChange={handleTemplateFieldsChange} />
        case 'text':
            return <Input property={property} propertyName={propertyName} handleTemplateFieldsChange={handleTemplateFieldsChange} />
        case 'color':
            return <Input property={property} propertyName={propertyName} handleTemplateFieldsChange={handleTemplateFieldsChange} />
        default:
            return null;
    }
}

const Select = (props) => {

    const { property, propertyName, handleTemplateFieldsChange } = props;

    return (
        <>
            <label htmlFor={property.propertyName} className="block text-sm font-medium">{property.propertyName}</label>
            <select id={property.propertyName} name={property.propertyName} onChange={(e) => handleTemplateFieldsChange(propertyName, e.target.value)} className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md text-gray-700 max-w-[300px]" defaultValue={property.propertyValue}>
                {
                    property.propertyOptions.map((option, index) => (
                        <option key={index} value={option.optionValue}>{option.optionName}</option>
                    ))
                }
            </select>
        </>
    )
}

const Input = (props) => {

    const { property, propertyName, handleTemplateFieldsChange } = props;

    return (
        <>
            <label htmlFor={property.propertyName} className="block text-sm font-medium">{property.propertyName}</label>
            <input onChange={(e) => handleTemplateFieldsChange(propertyName, e.target.value)} className='text-gray-700 py-1 px-2 rounded outline-none' type={property.propertyType} id={property.propertyName} value={property.propertyValue} />
        </>
    )
}

